import ActionTypes from '../Actions/ActionTypes';

let initialState = {
  Playlist: [],
  PublicPlaylist: [],
  SongsList: []
};

const PlaylistReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAYLIST:
      state = { ...state, Playlist: action.payload };
      break;
    case ActionTypes.GET_PUBLIC_PLAYLIST:
      state = { ...state, PublicPlaylist: action.payload };
      break;

        case ActionTypes.GET_PLAYLIST_SONGS:
      state = { ...state, SongsList: action.payload };
      break;
    default:
      break;
  }
  return state;
};

export default PlaylistReducer;
